module.exports = __webpack_public_path__ + "img/17.75f78490.jpg";